import React, { useState } from "react";

//STYLES
import * as ControllerStyles from "../styles/controller";

function ColorFade(props) {
    const [animColor, setAnimColor] = useState("yellow");

    function handleOnEnter() {
        setAnimColor("red");
    }

    function handleOnLeave() {
        setAnimColor("yellow");
    }

    return (
        <div
            style={{ ...ControllerStyles.menu_colorFadeAnimation, ...props.style, backgroundColor: animColor }}
            onMouseEnter={handleOnEnter}
            onMouseLeave={handleOnLeave}
        ></div>
    );
}

export default ColorFade;
